export default "__VITE_ASSET__C1YTTZY8__"